import React, { useEffect, useState, useMemo } from "react";
import { Table } from "antd";
import axios from "axios";
import { transactionColumns } from "../columns/transactionColumns";
import { LedgerResponsiveWrapper, API_BASE, getArn, rowMatchesSearch } from "../LedgerResponsive";

export default function TransactionTable({ folio, pan, schemeCode, onOpenModal, searchQuery }) {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!folio || !pan || !schemeCode) return;
    setLoading(true);

    axios
      .get(
        `${API_BASE}/get_transactions.php?pan=${pan}&folio_number=${folio}&scheme_code=${schemeCode}&arn_no=${getArn()}`
      )
      .then((res) => {
        console.log("👉 Transactions API Response:", res.data);
        if (res.data && Array.isArray(res.data.transactions)) {
          setTransactions(res.data.transactions);
        } else {
          setTransactions([]);
        }
      })
      .catch((err) => {
        console.error("❌ Transactions API Error:", err);
        setTransactions([]);
      })
      .finally(() => setLoading(false));
  }, [folio, pan, schemeCode]);

  const filtered = useMemo(() => transactions.filter(r => rowMatchesSearch(r, searchQuery)), [transactions, searchQuery]);

  return (
    <LedgerResponsiveWrapper>
      <Table
        loading={loading}
        columns={transactionColumns(onOpenModal)}
        dataSource={filtered}
        rowKey="id"
        pagination={false}
        bordered
        sticky
        scroll={{ x: "max-content" }}
        tableLayout="auto"
        // ❌ expandable हटा दिया ताकि plus icon गायब हो जाए
      />
    </LedgerResponsiveWrapper>
  );
}
